function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import FeedbackBtn from "./feedbackBtn";
import { ArrowRightOutlined } from '@ant-design/icons';
import { Space } from 'antd';
import cx from 'classnames';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var FeedbackPopover = function FeedbackPopover(props) {
  var defaultData = [{
    id: '1',
    logo: 'https://fanruanbbs.obs.cn-east-2.myhuaweicloud.com/ui/digit-fe/feedback/support.png',
    title: '在线支持',
    href: 'https://service.fanruan.com/support',
    subTitle: /*#__PURE__*/_jsx("div", {
      className: "grey-text",
      children: "\u83B7\u53D6\u4E13\u4E1A\u6280\u672F\u652F\u6301\uFF0C\u5FEB\u901F\u5E2E\u52A9\u60A8\u89E3\u51B3\u95EE\u9898"
    }),
    info: /*#__PURE__*/_jsx("div", {
      className: "grey-text",
      children: "\u5DE5\u4F5C\u65E59:00-12:00\uFF0C13:30-17:30\u5728\u7EBF"
    }),
    extra: /*#__PURE__*/_jsx("img", {
      className: "extra-img",
      src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABMCAYAAADHl1ErAAAAAXNSR0IArs4c6QAADT9JREFUeF7tnAu8TVUex7/nSkkiQpQkIWoQFTGmh3yaVHpQ0UtoEDevMpJP91mZpEwkj0J6N41KTe+MKb0kGZVGKaMRoVAoee/5/M7a6+5999nnnnO457ou6/PxOffsvfbea333/73WETk/x8ndBTmoOUDE/dR3+7c+kznvdrMfMZc7EImAo+fsxv2j93PIfTM/khd4VIl9jaLokO3kRCA3OMFEwIJ8g6NOxDumvwtTUMNekH3eLsidtZeg2aEVQCs0iQCRGAEMTjDV95xIooP38/WXpM26s+QlrQCYlTQccu0bluoUUqFUgSTon6oExtxuL0ArBEwDan+7k5MRITdsrkGAFmaBCiUAlKpAJfV+ShhaDDALTTYtZsCJRGJPzydFKLaTA7mzS0g9Q4FZaPgcQdhciptPUfcrfxB0Pxte+QTW/BTqE0oEWlxgGtLZI4x6xosCEnnRhAITIGRV/owT4fBD4a2FJgSpcyRkdYWGR8MPG2DIFFj1U2zUQyT9klYksKikjXBynDg2LRGQRBIYdv2ZJ0PuVQbUvTNh63a4+RKoeIjp/fX3kPcMfL8+/Onynm+PTJ/3TAjMSlpUPROEEYmcQjLnMzJgcCfo1MpA8zuUmXNhwmuwY6erkvECYdIHLSlgfmiJpKo4ztetARP7eVK1ZRuMnAHvfhHIRIp+WFokLWlgGtuZI5yciENu1HappRjqB1X06GpGtfypUseWMKgTVDjYo6Hzo1+AV+cXBla+PHRsAV99D1+tDPeec4pZPVMCFoU23MmJZLghR6LAqohM4ZDyMGM4/Gc5jP0HbPgVhl4G7Zt5E3/+QzioHFzcCjb9Bj3Gwvpf4Lga0LYxdGkLRx4Ov2yBW6bClysDqbBMyC5y59xdfDYtZWAWmmxaolSpKJt1bjPI7mbgbNthgNWoYr7/ugXufg7mLIJIBvz1Bjj4INi8FRodDVUOKyxN/10NU96Efy+DzVtcKfR3cYoP2m4B01jaSdICwW0qTkF92zWBW7tA5Yre7GSv+k+Gb1ZB+XKQeQF0bhOrboL3wlz4YDEsWg4nHQsjr4NbH4UvV4Sr53vFIGm7DcwPzcZpqRj8ww6BYZ0Lq6C9Xuo3Zias2wRtm0CXNqDAVU2gbIgx7mX4+/tQrRJMGQA1KsP6TXD5PbB9R2i5KndPoe0RsCi0YU4O1qbFIXZaA1ixFlYrQo9Akzom1pLRV/ttG9w3EzIicH17+PBLEz7ofP7VUL+W6bf4O8h+Cn7fBAZfbI6Nf8XYs5YnmO93PgtvLHAHElOvih7fI2h7DEwjaDvMyYnECW4VVz0xxEjIwMlwTjPo80djzNWWroKsp2D5j8Zg2+zh/JZwy6Wet5SK9h4P290YTAZ/iAvNvqdX5sPdM4zzLqopuP3gnt1zBMUCrACabJp9q+7ka1aG6YONnZKaWNXS6Rc/Mh5S0Xy0ewTkPYdeCh1PNcd0TsfUps0y/zKAHudCjw5GKtV++gW6jjYqa1uC8tRuQSs2YBaaRD74dpUDjuvtGXdNatRzMOvTwj1PqAX510C9mub44hWQ9SSc3wL+dJ459uQ7xlOe3tB8l5OwMZvgP/tekcIVPJkytGIFptGcMczJyXCh+cMOQXugN6z5GW5/Ar5b6xUnJVmKtWSXrDQ99wGMfRl27jQq1vNc6O1Cs7NWXql7tT7R5Jtq9wvau3GghSS3ypPnpqCexQ7MQlPIEVSJY6vD6p+9XFAkKlaA4Z2hwymFJ/nRErh1OmzdAeUi0L29AWZzS8VePccZNRfQy9sam7dwGQyeYmK7ZDORVKClBVgU2lAnR+WWQhgCkW6jOnDXNVCnuum1Yh089IaRliMOA0GT6o64AuRp1fx2cOpboH/WyMtTCtiuXe5THahUETq3Nqq8Ux3tGIJC6JA7997EjiBtwCw0VUPDUs/zWkDWlZ4TmP053PWsMdqyZeP7GmiavDyt2v9+hNsehbObGk+rNuUtE+WrBQPnQw+Gx4aYetq/Pjfqq/vF86Ia67wE0NIKTJNoNdTLCPwqetQRpiJxzJEmQO022uSLduKSqk6ne2Iw5wtTB1PapNarA1xzFox5ERROxGsXnAq3dzXe1ELbaSUw5KJE0NIOzEKLes+ASh5VFSbeaKCp2pA5ybz9vKug3UmFZzP3Kxgmm7bds2OVKpjEu6DaEQTgGvkLTjMVWwtt0utG7Se8Gp5GaeVs3phw9SwRYJrHaTd75W7/Q/2SJmhSI9XD1JQZaHLynlJPQfvzI65Bj7NQf1xNyOlmYHz8jVe9uNAHzUq6JFovKaw0FA9aiQGz0KIJu/tUO/CaVWByfyNptkVV8GnYtAUa1IIJ/Uwcl/UEvLkw3GZJPEf3hLN+Z+Kzm6fB/K9N9qDMYsKNcMrx3jM++xaGPwZrN7jHAmGHMoL5AUkrUWAWWlhwW6sqTHJtmqL2K0bBxs3e5BrUhqqHw8dLPKMdElZRoTzc1wtaNYItWg+YAvOXQnZXuMhnE3Xn2Z/BiMehKJumsfqhlTiwoqBJPa2kqUTTf6KRMGujgl6wRX3QosmM901IYs8r8h9joUnSpsK3a2BSJlSvDC/NgyvbGZuWKrS9AkzQWg4OT9glaUFoG33e06px5oXQ/Rwvl5Qden+xqWgsXQ1rN8K9gtbQqOeQqbBuI1x4Ojz1DrRpbAqYFtptj5sXU7sarFwb6z6lngvuj+TtNWAWmoLbgjjNXQWSpD2UaWzaAy/D9NnuBHxeVnZPFYvL2pgydbAp0l+1HuQE1PRdEqii5Lc/QJ8HDTQ5COs9tRba6BjInGjy2GCmkpHB3gXmh6a//QOUpLU4Hl5b4JZ91CHWKCO40wcR/Uy2yWap8KiFFdk1C81e/+MGuGQkbN0WmxjsVQmzA2wxyMkmYt6eP3NJtCilVOgv13lrAcoSVEBctsYUH2tXNcXHDZuhZX1o7npIlbG1qq7W7Q8mBy3nZhOCqcWWL5bH30+Y7ItJa78oNMgrlOqFSJRNvlW9UL3fpk2CNPQRA8s2lYkeGQh9Jxg1HNsbWst7boNBD5tVpseHeHGfve6fn5q1gTDvWSokzC9pDhRsxwxbxdOK0chrTa3fNklL7tPGRm3b7lVl1eeBPrBpc3xoy36AB2+EFz40WYNK57Jp8aCVKmAC0HyQkx1xoQWBKei8pwfI4KtJAsa+BI+9Dc3qwajusGQVDJ3qQZONUlFS0PpI0tbAuD6epA18GD7+2gtdtEUh72oDTQVOlZiiVY6okfXZ07TqW4o3bz7AyXYinqTZy7V4MjkTqlQ0YYNyywVLjd2rWx2mDjQw31kEQ6fFQlMg3PdBkFSpAqxdQlJPQZvnQpOUXnSagSxocg6qokRbpJQCi0paHGiN60D/jpD/NwPN34LQtBq+XZUJx3jDO6412YNCCtk0P7QBgrbEu5sqJZe0DqROIWvEKcpCers3HWAcQbJPkXSoqjvNJ2m3TPOSdUEogDbeSJpsnJW0mx4qDC3suaXOhgUHmQw0pTky2jY4FTR5x5pHmIKk0ibV/7VUd3Jd6NAcfv4V+rjQVKyU91QOe9EdXl1unwSmQTfNdG1aSKBWqxq8nmNyQoUVtkKrYDRsi4EfgqD1GmfWRFVCUsqkxZm4rTTbsBhJs9B8J2TsG9Y2sVSlQ01SrVRq1PXeSrjtvsuBT74xO38kebY9865n1JPdjJSsidjr/U7O9IJb12lFPWSz4+Dhmww0rYwrX1Rbuc5sQRjexUB6e5HZH6tqhtYNtEdj7hKzlBe9X2CHZdjuo1Jvw4JvSdD8wa0939SFpgRabdZCswisSoekSvlmFNrnZhnObjlIRQoEa58DpglaaEEJUPCqqqo2sjw9p3Ayr7L3o4NNkq7FEEHTXtngPtqiAEb7pkK4NPVtnOlkRxzyCu3lwGy8iy7ihjQLTQ5i9POwxb/YG6iW+FXeD2mfBaYJNe5nbFrSv42KEC1hq3SdVAt4AT1nnwZmoVmbFow6Yn54EaRUxB7cMAmLt2ieFPzS1KlRPy9hT/e49nkJs4DCoCX6+WKiMCIMfpkBpsk16msygnROKp33Trd2hN6/Qd9iVM+QVKzMARPFeNCSTX3i7e7ZZwPXZERX0BzHhBzxFoIT3ScmNdpXI/1EE7Xn6/d2srWWGHd3T7I38vUrkyrp5yBoEbfcnUglE/ErM3FYookKmn8Jz9qomEA3cKOw31KVeQmzDOrd4GRHMsjzrxSnunBso/9EL6jMnK8n9bQJe1iyXRbrYXv69iRp2pawu/fZb1TSD6iu1NOtcvjrYcn8Jn2/BCZ4Floqm1/KdOCajMrV7elkYx1BUfUcn1vdbyXMApWkIUeQxC9t9jsvGU/q6kjSQmxamS/vJKOG8foc28vJchzyg2sEwf77vUr6gRRAcw+GpVIHgAVE6JgeThaQHz0ctgNyT8S4rF4raI6FFqhUHJCwOG9d0HY55Af/S8MDwIpQk1rdnaxIhHx/AfIAsAR2pZZsmrynG6gdAJaEIa4pSYP8/T41SoJVQZcoNNm0VC7a3/sK2v8BlkC1wZsZYNEAAAAASUVORK5CYII="
    })
  }, {
    id: '2',
    onClick: function onClick() {},
    title: '页面反馈',
    subTitle: /*#__PURE__*/_jsx("div", {
      className: "grey-text",
      children: "\u9488\u5BF9\u5F53\u524D\u7F51\u9875\u7684\u5EFA\u8BAE\u3001\u95EE\u9898\u53CD\u9988"
    }),
    componentWrapper: /*#__PURE__*/_jsx(FeedbackBtn, _objectSpread({
      onClick: props.onClose
    }, props)),
    logo: 'https://hwobs.fanruan.com/ui/digit-fe/feedback/feedback.png' //content: (
    //  <FeedbackBtn onClick={props.onClose} {...props}>
    //    <div className="dr-feedback-popover-item-logo">
    //      <img
    //        alt="feedback"
    //        src="https://hwobs.fanruan.com/ui/digit-fe/feedback/feedback.png"
    //      />
    //    </div>
    //    <div>
    //      <Space className="dr-feedback-popover-item-title-wrapper">
    //        <span className="title">页面反馈</span>
    //        <ArrowRightOutlined className="icon" />
    //      </Space>
    //      <div className="grey-text">针对当前网页的建议、问题反馈</div>
    //    </div>
    //  </FeedbackBtn>
    //),

  }, {
    id: '3',
    logo: 'https://hwobs.fanruan.com/ui/digit-fe/feedback/tel.png',
    title: '售前咨询',
    subTitle: '采购需求/获取报价/预约演示',
    info: /*#__PURE__*/_jsxs("div", {
      className: "grey-text",
      children: ["\u6216\u62E8\u6253: ", /*#__PURE__*/_jsx("span", {
        children: "400-811-8890 \u8F6C1"
      })]
    }),
    extra: /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx("img", {
        alt: "qr",
        src: "https://fanruanbbs.obs.cn-east-2.myhuaweicloud.com/ui/digit-fe/feedback/qr.png",
        width: 80
      })
    })
  }, {
    id: '4',
    logo: 'https://hwobs.fanruan.com/ui/digit-fe/feedback/consult.png',
    title: '热线电话',
    subTitle: /*#__PURE__*/_jsx("div", {
      className: "grey-text",
      children: "\u54A8\u8BE2/\u6545\u969C\u6551\u63F4\u70ED\u7EBF\uFF1A400-811-8890\u8F6C2"
    }),
    info: /*#__PURE__*/_jsx("div", {
      className: "grey-text",
      children: "\u603B\u88C1\u529E24H\u6295\u8BC9\uFF1A17312781526"
    })
  }];
  var popoverData = props.popoverData,
      className = props.className;

  var renderData = function renderData() {
    var renderPopoverData = function renderPopoverData(item) {
      if (item.content) {
        return /*#__PURE__*/_jsx("div", {
          className: cx((item.href || item.onClick) && 'dr-feedback-popover-item-click', 'dr-feedback-popover-item'),
          children: item.content
        }, item.id);
      }

      var renderContent = function renderContent() {
        return /*#__PURE__*/_jsxs(React.Fragment, {
          children: [item.logo && /*#__PURE__*/_jsx("div", {
            className: "dr-feedback-popover-item-logo",
            children: /*#__PURE__*/_jsx("img", {
              src: item.logo
            })
          }), /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsxs(Space, {
              className: "dr-feedback-popover-item-title-wrapper",
              children: [typeof item.title === 'string' ? /*#__PURE__*/_jsx("span", {
                className: "title",
                children: item.title
              }) : item.title, (item.href || item.onClick) && /*#__PURE__*/_jsx(ArrowRightOutlined, {
                className: "icon"
              })]
            }), typeof item.subTitle === 'string' ? /*#__PURE__*/_jsx("div", {
              className: "grey-text",
              children: item.subTitle
            }) : item.subTitle, item.info && /*#__PURE__*/_jsx("div", {
              className: "dr-feedback-popover-item-info-wrapper",
              children: typeof item.info === 'string' ? /*#__PURE__*/_jsx("div", {
                className: "grey-text",
                children: item.info
              }) : item.info
            })]
          }), item.extra]
        });
      };

      var renderWrapperContent = function renderWrapperContent() {
        var WrapperComponent = item.componentWrapper.type;
        return /*#__PURE__*/React.createElement(WrapperComponent, item.componentWrapper.props, renderContent());
      };

      return /*#__PURE__*/_jsx("div", {
        className: cx((item.href || item.onClick) && 'dr-feedback-popover-item-click', 'dr-feedback-popover-item'),
        onClick: function onClick() {
          var _props$onClose;

          if (item.href) {
            window.open(item.href);
          } else if (item.onClick) {
            item.onClick();
          }

          (_props$onClose = props.onClose) === null || _props$onClose === void 0 ? void 0 : _props$onClose.call(props);
        },
        children: item.componentWrapper ? /*#__PURE__*/_jsx(React.Fragment, {
          children: renderWrapperContent()
        }) : /*#__PURE__*/_jsx(React.Fragment, {
          children: renderContent()
        })
      }, item.id);
    };

    if (popoverData) {
      return popoverData(defaultData).map(function (item) {
        return renderPopoverData(item);
      });
    }

    return defaultData.map(function (item) {
      return renderPopoverData(item);
    });
  };

  return /*#__PURE__*/_jsx("div", {
    className: cx(className, 'dr-feedback-popover'),
    children: renderData()
  });
};

export default FeedbackPopover;